import { JsFormResponseHandlerObject } from '../general/modules/jsFormTypes';
import { LoginFormContent } from '../view/login-form-content';
import { open2FaOtpPopup } from '../general/handlers/otp2FaFormHandler';
import { getUrlToLoginViaToken } from './getUrlToLoginViaToken';
import { addLoginQueryParams } from '../utils/url';
import { GetUserTokenType } from '../domains/valueObject/SwitchUserProgressResponses';
import axios from 'axios';
import { Localization } from '../localization/localization';
import { RpcReceivedError } from '@scorewarrior/rubens_web_lib/lib/errors/rpc-received-error';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';
import { ClientApiErrorCodes } from '@scorewarrior/rubens_web_lib/lib/hub-api/constants/client-api-error-codes';

type LoginError = {
    error?: {
        code: number,
        message: string
        data?: {
            id: number,
            token: string,
            deleteAt: string
        }
    }
}

function emailLoginFormHandler(data: JsFormResponseHandlerObject<LoginError>): void {
    const response = data.response;
    const loginForm = LoginFormContent.fromForm(data.form, data.caller.data('tooltipdirection'));

    loginForm.hideErrors();

    if (response.error) {
        if ([ClientApiErrorCodes.EMAIL_EMPTY].includes(response.error.code)) {
            loginForm.showEmailError(response.error.message);
            return;
        }

        if ([
            ClientApiErrorCodes.PASS_EMPTY,
            ClientApiErrorCodes.WRONG_PASSWORD
        ].includes(response.error.code)) {
            loginForm.showPasswordError(response.error.message);
            return;
        }

        if ([ClientApiErrorCodes.REQUIRE_2FA].includes(response.error.code)) {
            const emailField = $('input[name=email]', data.form);
            const email: string = (emailField.val() as string || '').toString().trim();
            open2FaOtpPopup(email);
            return;
        }

        if ([ClientApiErrorCodes.ACCOUNT_TO_BE_DELETED].includes(response.error.code)) {
            window.app.handleAccountToBeDeleted(
                response.error.data.id,
                response.error.data.token,
                response.error.data.deleteAt
            );
            return;
        }

        loginForm.showSubmitButtonError(response.error.message);
    } else {
        location.reload();
    }
}

async function loginThroughHub(form: JQuery): Promise<LoginError> {
    const emailField = form.find('input[type=email]');
    const email: string = (emailField.val() as string).trim();
    const passwordField = form.find('input[type=password]');
    const password: string = (passwordField.val() as string).trim();

    try {
        const hubApi = getHubApi();
        const hubResponse: GetUserTokenType = await hubApi.getTokenEmail(window.app.deviceIdentifier, {
            email,
            password,
            current_entry_point: window.app.config.current_entry_point,
            locale: window.app.config.locale
        });

        let url = getUrlToLoginViaToken(hubResponse.tether.token, hubResponse.tether.suid);
        url = addLoginQueryParams(url);
        await axios.get(url);

        return {};
    } catch (error) {
        if (error.code === ClientApiErrorCodes.ACCOUNT_TRANSFERRED) {
            window.app.handleAccountTransferredWindow();
        }

        if (error instanceof RpcReceivedError) {
            return {
                error: {
                    code: error.code,
                    data: error.data,
                    message: getErrorMessage(error.code)
                }
            };
        }

        window.Sentry.captureException(error);
        return {
            error: {
                code: ClientApiErrorCodes.COMMON_ERROR,
                message: Localization._n('errors.common_error')
            }
        };
    }
}

function getErrorMessage(errorCode: number): string {
    let msg: string;
    switch (errorCode) {
        case ClientApiErrorCodes.NOT_REGISTERED:
            msg = 'login.email_not_exists';
            break;
        case ClientApiErrorCodes.WRONG_PASSWORD:
            msg = 'errors.pass_wrong';
            break;
        case ClientApiErrorCodes.REQUIRE_2FA:
            msg = 'login.2fa_required_sending';
            break;
        case ClientApiErrorCodes.USER_MUST_CHANGE_PASSWORD:
            msg = 'login.must_change_password';
            break;
        case ClientApiErrorCodes.EMAIL_EMPTY:
            msg = 'errors.email_empty';
            break;
        case ClientApiErrorCodes.PASS_EMPTY:
            msg = 'errors.pass_empty';
            break;
        case ClientApiErrorCodes.ACCOUNT_TO_BE_DELETED:
            msg = 'errors.account_to_be_deleted';
            break;
        case ClientApiErrorCodes.ACCOUNT_TRANSFERRED:
            msg = 'errors.account_is_transferred';
            break;
        default:
            msg = 'error.operation_failed';
    }

    return Localization._n(msg);
}

export function initLoginHandlers() {
    window.app.login_form_handler = emailLoginFormHandler;
    window.app.login_send_request_handler = loginThroughHub;
}
